import { createReducer } from '@reduxjs/toolkit';

import * as contentActions from './contentActions.js';

const initialState = {
  id: 0,
  uid: 0,
  type: '',
  isActive: false,

  headingTitle: '',
  headingDescription: '',
  items: [],
  // Items per row (gallery/features): '' = not set, the editor resolves the per-variant default.
  view: '',

  code: '',
  terms: '',
  url: '',

  label: '',
  endDate: '',

  // html block — named after the block, not the column, so it does not read as `content.content`.
  html: '',
  readMoreLabel: null,
};

const content = createReducer(initialState, (builder) => {
  builder
    .addCase(contentActions.contentStore, (state, { payload: section }) => {
      const data = section?.[section?.type] ?? {};

      return {
        ...state,
        id: section?.blockId ?? 0,
        uid: section?.uid ?? 0,
        type: section?.type ?? '',
        isActive: section?.isActive ?? false,
        headingTitle: data.headingTitle ?? '',
        headingDescription: data.headingDescription ?? '',
        items: data.items ?? [],
        view: data.view ?? '',
        code: data.code ?? '',
        terms: data.terms ?? '',
        url: data.url ?? '',
        label: data.label ?? '',
        endDate: data.endDate ?? '',
        html: data.content ?? '',
        readMoreLabel: data.readMoreLabel ?? null,
      };
    })
    .addCase(contentActions.contentClear, () => ({ ...initialState }))

    .addCase(contentActions.contentUpdateHeadingTitle, (state, { payload }) => ({ ...state, headingTitle: payload }))
    .addCase(contentActions.contentUpdateHeadingDescription, (state, { payload }) => ({ ...state, headingDescription: payload }))
    .addCase(contentActions.contentUpdateItems, (state, { payload }) => ({ ...state, items: payload }))
    .addCase(contentActions.contentUpdateView, (state, { payload }) => ({ ...state, view: payload }))
    .addCase(contentActions.contentUpdateCode, (state, { payload }) => ({ ...state, code: payload }))
    .addCase(contentActions.contentUpdateTerms, (state, { payload }) => ({ ...state, terms: payload }))
    .addCase(contentActions.contentUpdateLabel, (state, { payload }) => ({ ...state, label: payload }))
    .addCase(contentActions.contentUpdateEndDate, (state, { payload }) => ({ ...state, endDate: payload }))
    .addCase(contentActions.contentUpdateHtml, (state, { payload }) => ({ ...state, html: payload }))
    .addCase(contentActions.contentUpdateUrl, (state, { payload }) => ({ ...state, url: payload }))
    .addCase(contentActions.contentUpdateReadMoreLabel, (state, { payload }) => ({ ...state, readMoreLabel: payload }));
});

export default content;
